// extracted by mini-css-extract-plugin
export default {"slider":"XIv4d","slider-short":"_15YE1","sliderShort":"_15YE1","slider-adoptables":"_3047v","sliderAdoptables":"_3047v","slider-item":"_3uafI","sliderItem":"_3uafI"};